import FileUpload from "../components/FileUpload";
import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from 'react';
import { useSession } from "../components/SessionProvider";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import { useApi } from "../hooks/useApi";

export default function Upload() {
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');   // empty string = no error
  const [done, setDone] = useState(false);
  const { apiCall } = useApi();
  const initialized = useRef(false);
  const [message, setMessage] = useState("");
  const { userLogin } = useSession();
  const [clearSheetsOpen, setClearSheetsOpen] = useState(false);
  const [clearCodesOpen, setClearCodesOpen] = useState(false);
  const [usersSiteOpen, setUsersSiteOpen] = useState(false);
  const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';
  const [ifUploadPossible, setIfUploadPossible] = useState(true);

  const clearSheetsdataFunction = async () => {
    try {
      const response = await apiCall(`clearSheetsdata`, {
        method: "POST",
      });
      const data = await response.json();
      setMessage(data.message || data.error);
      setClearSheetsOpen(false);
    } catch (error) {
      setMessage("Error clearing data.");
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Reload the page after 2 seconds
    }
  };
  const clearCodesFunction = async () => {
    try {
      const response = await apiCall(`clearCodes`, {
        method: "POST",
      });
      const data = await response.json();
      setMessage(data.message || data.error);
      setClearCodesOpen(false);
    } catch (error) {
      setMessage("Error clearing data.");
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Reload the page after 2 seconds
    }
  };
  const clearSitesAndUsersFunction = async () => {
    try {
      const response = await apiCall(`clearSitesAndUsers`, {
        method: "POST",
      });
      const data = await response.json();
      setMessage(data.message || data.error);
      setUsersSiteOpen(false);
    } catch (error) {
      setMessage("Error clearing data.");
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Reload the page after 2 seconds
    }
  };
  const requestCSVCheck = async () => {
    try {
      const response = await apiCall(`clearSitesAndUsers`, {
        method: "POST",
      });
      const data = await response.json();
      setMessage(data.message || data.error);
      setUsersSiteOpen(false);
    } catch (error) {
      setMessage("Error clearing data.");
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Reload the page after 2 seconds
    }
  };
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      const fetchStatus = async () => {
        try {
          const response = await apiCall(`getSubmissionStatus`);
          const data = await response.json();

          if (data.count == 0) {
            setDone(true);
            setStatus('');
          } else {
            setDone(false);
            setError(`There are still ${data.count} unsubmitted invoices. Make sure you know what you are doing.`);
          }
        } catch (err) {
          setError('Error loading status');
          setDone(false);
        } finally {
        }
      };

      fetchStatus();
      /*  apiCall(`checkIfSheetsCanBeUploaded`) // Update with your actual API endpoint
         .then((response) => {
           if (!response.ok) {
             throw new Error("Failed to fetch sites");
           }
           return response.json();
         }).then((result) => {
           setIfUploadPossible(result);
         }); */
    }
  });
  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-10">
        <h1 className="text-2xl font-bold">Upload Files</h1>
        <Link to="/" className="btn btn-primary">
          Back
        </Link>
      </div>
      {!done && (
        <div className="mb-3  flex flex-col items-center">
          <div style={{ background: '#dae4ef' }} className="mb-3 text-center p-2 text-sm relative">

            {error && (
              <span style={{ color: 'red' }}>{error}</span>
            )}
            {!error && status && (
              <span>{status}</span>
            )}
          </div>

        </div>
      )}

      {ifUploadPossible !== true && (
        <p>Upload is not possible until the new cost codes have been imported.</p>
      )}
      {ifUploadPossible === true && (
        <>
          <h3>Remember to upload the Coding Sheet first then the Detailed Invoices PDF.</h3>
          <div className="flex justify-between items-center mb-4 mt-7">
            <div className="w-[50%]">
              <p className="mb-1">1. Upload Coding Sheet</p>
              <FileUpload type="codingSheet" />
            </div>
            <div className="w-[50%] flex justify-end">
              <div>
                <p className="mb-1">2. Detailed Invoices PDF</p>
                <FileUpload type="detailedInvoice" />
              </div>
            </div>

          </div>

        </>)}

      {isDevelopment && (
        //we are not uploading anything anymore.
        <>
          <hr></hr>

          {/*  <div className="flex justify-between items-center mb-4 mt-7">
            <div className="w-[50%]">
              <p className="mb-1">Upload Cost Codes</p>
              <FileUpload type="codes" />
            </div>
            <div className="w-[50%] flex justify-end">
              <div>
                <p className="mb-1">Upload Projects &amp; Users</p>
                <FileUpload type="sites" />
              </div>
            </div>

          </div> */}


          <div className="border-t-2 pt-4"></div>
          <h3 className="text-bold text-2xl">Clear Data</h3>
          {userLogin && userLogin.isAdmin && (<button onClick={() => setClearSheetsOpen(true)} className="my-3 mr-2 bg-orange-500 text-white px-4 py-2 rounded disabled:opacity-50 hover:bg-orange-600 cursor-pointer">Clear Sheets Data</button>)}
          {/* {userLogin && userLogin.isAdmin && (<button onClick={() => setClearCodesOpen(true)} className="my-3 bg-orange-500 mr-2 text-white px-4 py-2 rounded disabled:opacity-50 hover:bg-orange-600 cursor-pointer">Clear Codes</button>)} */}
          {/* {userLogin && userLogin.isAdmin && (<button onClick={() => setUsersSiteOpen(true)} className="my-3 mr-2 bg-orange-500 text-white px-4 py-2 rounded disabled:opacity-50 hover:bg-orange-600 cursor-pointer">Clear Projects and Users</button>)} */}

        </>
      )}


      <ConfirmDialog
        open={clearSheetsOpen}
        title="Confirmation"
        message={'Are you sure you want to remove all the coding sheets'}
        confirmText="Clear"
        cancelText="Cancel"
        onConfirm={clearSheetsdataFunction}
        onCancel={() => setClearSheetsOpen(false)}
      />
      <ConfirmDialog
        open={clearCodesOpen}
        title="Confirmation"
        message={'Are you sure you want to remove all the codes?'}
        confirmText="Clear"
        cancelText="Cancel"
        onConfirm={clearCodesFunction}
        onCancel={() => setClearCodesOpen(false)}
      />
      <ConfirmDialog
        open={usersSiteOpen}
        title="Confirmation"
        message={'Are you sure you want to remove all sites and unassign users?'}
        confirmText="Clear"
        cancelText="Cancel"
        onConfirm={clearSitesAndUsersFunction}
        onCancel={() => setUsersSiteOpen(false)}
      />
      {message && <p className="py-3">{message}</p>}

    </div>
  );
}
